import React, {useEffect, useState, useRef} from 'react';
import styles from "./ExitOverlay.module.scss";
import ehl from './../../images/svgs/ehl.svg';

import xIcon from './../../images/svgs/white-x-icon.svg';
import logo from './../../images/svgs/wellsfargo-logo.svg';

import {fireGA} from '../../hooks/tagging'
import classNames from "classnames";

const ExitOverlay = ({
                         closeExitOverlay = () => {
                         }, addExitClickListeners = () => {
    }
                     }) => {

    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!loaded) {
            addExitClickListeners();
            setLoaded(true);
        }
    }, [loaded])

    const link = useRef<HTMLAnchorElement>(null);
    const cancel = useRef<HTMLButtonElement>(null);

    return (
        <section className={classNames([styles.overlay, 'no-parallax'])} id="overlay">
            <div id="modal"
                role="dialog"
                aria-modal="true">
                <div id="modal-top-ribbon">
                    <img className="logo" src={logo} alt={process.env.REACT_APP_LANG === 'spanish' ? "Logotipo de Wells Fargo" : "Wells Fargo logo."}/>
                    <button id="modal-x-icon" onClick={() => {
                        closeExitOverlay();
                        fireGA('interstitial-close', {innerText: "close exit modal"});//good
                    }} tabIndex={-1}>
                        <img src={xIcon} alt={process.env.REACT_APP_LANG === 'spanish' ? "X - Cierra la ventana emergente" : "Closes the overlay window."}/>
                    </button>
                </div>
                <div id="modal-body">
                    <p className="modal-headline" role="heading">
                        {
                            process.env.REACT_APP_LANG === 'spanish' ? <>Está saliendo del sitio Web de Wells Fargo</> : <>You are leaving the Wells&nbsp;Fargo&nbsp;website</>
                        }
                    </p>
                    <p>
                        {
                            process.env.REACT_APP_LANG === 'spanish' ?
                                <>Está saliendo de wellsfargo.com e ingresando a un sitio Web de un tercero. Aunque Wells Fargo tiene una relación con este sitio Web, Wells Fargo no proporciona los productos ni los servicios en este sitio Web (excepto nuestras apps de banca móvil). Consulte las políticas de privacidad y seguridad y los términos y condiciones aplicables del sitio Web que está visitando.</>
                                :
                                <>You are leaving wellsfargo.com and entering a third party website. Although <span lang="en">Wells Fargo</span> has a relationship with this website, <span lang="en">Wells Fargo</span> does not provide the products and services on this website (other than our mobile apps). Please review the applicable privacy and security policies and terms and conditions for the website you are visiting.</>
                        }
                    </p>
                </div>
                <div className="modal-links">
                    <button ref={cancel} id="modal-cancel" onClick={(e) => {
                        closeExitOverlay();
                        fireGA('interstitial-cancel', {innerText: "cancel"});//good
                    }}
                        aria-label={process.env.REACT_APP_LANG === 'spanish' ? "Cancele - El botón de cancelar cierra la ventana emergente" : "Cancel button closes the overlay window."} tabIndex={-1}>
                        {
                            process.env.REACT_APP_LANG === 'spanish' ? <>Cancele</> : <>Cancel</>
                        }
                    </button>


                    <a ref={link}
                        onClick={(e) => fireGA('interstitial-continue', {innerText: "continue"})} //good
                        onKeyUp={(e) => {
                        if (e.which === 13) {
                            link.current?.click()
                        }
                    }} id="modal-continue" href="#willgetreplaced"
                        aria-label={
                            process.env.REACT_APP_LANG === 'spanish' ?
                                "Continuar al enlace seleccionado - se abre en una nueva ventana del navegador" :
                                "Continue to the selected link - opens in a new browser window"
                        } target="_blank" tabIndex={-1}>
                        {
                            process.env.REACT_APP_LANG === 'spanish' ? <>Continúe</> : <>Continue</>
                        }
                    </a>
                </div>
            </div>
        </section>
    )
};

export default ExitOverlay;
